<template>
  <v-text-field
    :outlined="outlined"
    :color="color"
    :background-color="backgroundColor"
    :disabled="disabled"
    :readonly="readonly"
    :height="height"
    :flat="flat"
    :hide-details="hideDetails"
    :type="type"
    :solo="solo"
    :label="label"
    :prepend-inner-icon="prependInIcon"
    :placeholder="$t(placeholder)"
    :append-icon="appendIcon"
    :clearable="clearable"
    :value="value"
    :suffix="$t(suffix)"
    dense
    :rules="rules"
    :required="required"
    :oninput="returnOninput"
    :class="{ 'error-input': error }"
    :style="{ 'border-radius': '8px', width: width }"
    @keypress.enter="eventKeyEnter"
    @change="eventChange"
    @input="eventChange"
    @click:clear="eventClear"
    @click:append="eventClickAppend"
    v-bind="vBind"
    v-on="vOn"
  ></v-text-field>
</template>

<script>
export default {
  name: "TextField",
  props: {
    disabled: {
      default: false,
    },
    inputType: {
      default: null,
    },
    suffix: {
      default: "",
    },
    flat: {
      default: true,
    },
    outlined: {
      default: true,
    },
    color: {
      default: "var(--theme-color-one)",
    },
    backgroundColor: {
      default: "#fff",
    },
    height: {
      default: "36px",
    },
    width: {
      default: "300px",
    },
    hideDetails: {
      default: true,
    },
    solo: {
      default: true,
    },
    readonly: {
      default: false,
    },
    label: {
      default: "",
    },
    type: {
      default: "text",
    },
    placeholder: {
      default: "",
    },
    appendIcon: {
      default: "",
    },
    prependInIcon: {
      default: "",
    },
    clearable: {
      default: false,
    },
    value: {
      default: "",
    },
    error: {
      default: false,
    },
    rules: {
      default: () => [],
    },
    required: {
      default: false,
    },
    vBind: {
      default: () => ({}),
    },
    vOn: {
      default: () => ({}),
    },
  },
  computed: {
    returnOninput() {
      switch (this.inputType) {
        case "number":
          return "value=value.replace(/[^\\d]/g,'')"; // only number

        case "decimal":
          return "value=value.replace(/[^0-9\\.]/g,'')"; // only number and decimal

        default:
          return null;
      }
    },
  },
  methods: {
    eventChange(val) {
      this.$emit("onChange", val);
    },
    eventKeyEnter() {
      this.$emit("onEnter");
    },
    eventClear() {
      this.$emit("onClear");
    },
    eventClickAppend() {
      this.$emit("onClickAppend");
    },
  },
};
</script>

<style scoped></style>
